// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"6096":"css/app.6888","7882":"css/admin-app.6888"}[chunkId] + ".css";
};